export const styles = {
  infoContainer: {
    flex: 1,
    display: 'flex',
  },
  buttonsContainer: {
    padding: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 0,
  },
  imageColumn: {
    marginRight: '20px',
    minWidth: '80px',
  },
  info: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  image: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    position: 'absolute',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  userName: {
    fontSize: '22px',
    fontWeight: '700',
  },
  row: {
    display: 'flex',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px',
    width: '30%',
  },
  infoItemTitle: {
    color: '#707087',
    marginBottom: '5px',
    fontWeight: '200',
  },
  column: {
    marginRight: '30px',
  },
  loadingContainer: {
    width: '100%',
    height: '100%',
  },
  passwordContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  profileButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '16px',
    border: '1px solid',
    marginLeft: '20px',
    padding: '8px 16px',
    backgroundColor: '#FFFFFF',
    minWidth: '124px',
    fontWeight: '700',
  },
  editButtonLabel: { marginLeft: '5px', fontWeight: '700' },
}
